import { useEffect, useState } from 'react';
import NewRequests from '../../components/Admin/consultations/NewRequests';
import axios from 'axios';
import InProcess from '../../components/Admin/consultations/InProcess';
import Booked from '../../components/Admin/consultations/Booked';
import Accepted from '../../components/Admin/consultations/Accepted';
import Rejected from '../../components/Admin/consultations/Rejected';

function Consultations() {
    const [activeTab, setActiveTab] = useState("New Requests");
    const [consultationData, setConsultationData] = useState({
        Pending: [],
        Booked: [],
        "In Process": [],
        Approved: [],
        Rejected: [],
    });
    const [consultants, setConsultants] = useState([]);

    const fetchConsultations = async () => {
        const token = localStorage.getItem("token");
        if (!token) {
            // console.error("Token not found");
            return;
        }

        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/consultation/status`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });

            const data = response.data?.data || {};
            setConsultationData({
                Pending: data.Pending || [],
                Booked: data.Booked || [],
                "In Process": data["In Process"] || [],
                Approved: data.Approved || [],
                Rejected: data.Rejected || [],
            });
        } catch (error) {
            // console.error('Error fetching consultations:', error);
        }
    };

    const fetchConsultants = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/consultant/all`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                }
            });
            setConsultants(response.data.data || []);
            
            
        } catch (error) {
            // console.error('Error fetching consultants:', error);
        }
    };

    useEffect(() => {


        fetchConsultations();
        fetchConsultants();
    }, []);
//    console.log(consultationData)
   
   
    const renderContent = () => {
        switch(activeTab) {
            case "New Requests":
                return <NewRequests consultations={consultationData.Pending} consultants={consultants} fetchConsultants={fetchConsultants} fetchConsultations={fetchConsultations} />;
            case "In Process":
                return <InProcess consultations={consultationData["In Process"]} consultants={consultants} fetchConsultants={fetchConsultants} fetchConsultations={fetchConsultations} />;
            case "Booked":
                return <Booked consultations={consultationData.Booked} consultants={consultants} fetchConsultants={fetchConsultants} fetchConsultations={fetchConsultations} />;
            case "Accepted":
                return <Accepted consultations={consultationData.Approved} fetchConsultants={fetchConsultants} fetchConsultations={fetchConsultations} />;
            case "Rejected":
                return <Rejected consultations={consultationData.Rejected} fetchConsultants={fetchConsultants} fetchConsultations={fetchConsultations} />;
            default:
                return <NewRequests consultations={consultationData.Pending} consultants={consultants} fetchConsultants={fetchConsultants} fetchConsultations={fetchConsultations} />;
        }
    };

    return (
        <div className="relative pl-36 pr-12 mt-16 w-full py-8 min-h-screen">
            <div className="px-10 py-6 bg-white rounded shadow-md">
                <div className="flex mb-4 w-full border-b">
                    {['New Requests', 'In Process', 'Booked', 'Accepted', 'Rejected'].map((tab) => (
                        <button
                            key={tab}
                            className={`px-4 py-2 text-lg font-semibold flex-1 text-center ${activeTab === tab ? "text-blue-500 border-b-2 border-blue-500" : "text-gray-600"}`}
                            onClick={() => setActiveTab(tab)}
                        >
                            {tab}
                        </button>
                    ))}
                </div>
                {renderContent()}
            </div>
        </div>
    );
}

export default Consultations;
